import { createCachedSelector } from 're-reselect';

import getComponents from '@/state/selectors/exposer/get-components';
import { IStore } from '@/state/slices/typings';

const getComponent = createCachedSelector(
	[getComponents, (_: IStore, key: string) => key],
	(components, key) => components[key],
)((_: IStore, key: string) => key);

export default getComponent;
